<script setup lang="ts">

</script>

<template>

    <div class="page-content p-4 md:p-6 lg:p-8">
        <h1>404</h1>
        <p>Not Found</p>
    </div>
    
</template>

<style>

</style>
